import { makeVar } from "shared/providers/apollo/apollo.package";

/**
 * Store currently selected property language ID (returned from API)
 */
export const languageIdVar = makeVar<string | null>(null);
